import { connect } from 'react-redux';
import ParticipantsList from './ParticipantsList';
import { PARTICIPANTS_ROUTER_NEW, PARTICIPANTS_ROUTER_EDIT } from '../constants';
import { push } from 'react-router-redux/lib/actions';
import { listStateFromCRUD, listDispatchFromCrud } from '../../../selectors/crud';
import CRUDActions from '../../../actions/participant';
import { setHeaderTitle } from '../../../actions/layout';
import { getCurrentClubId } from '../../../selectors/club-settings';

export default connect(
  (state) => ({
    headerTitle: 'Opponents',
    ...listStateFromCRUD(state.participant),
    filter: {
      club_id: getCurrentClubId(state)
    }
  }),
  (dispatch) => ({
    updateHeaderTitle: (title) => dispatch(setHeaderTitle(title)),
    ...listDispatchFromCrud(dispatch, CRUDActions),
    edit: (id) => dispatch(push(PARTICIPANTS_ROUTER_EDIT.replace(':id', id))),
    add: () => dispatch(push(PARTICIPANTS_ROUTER_NEW))
  })
)(ParticipantsList);



// WEBPACK FOOTER //
// ./src/components/Participants/ParticipantsList/index.js